module.exports = __webpack_public_path__ + "static/img/应用场景1-车辆轨迹监控.731464a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type4-2/应用场景1-车辆轨迹监控.png
// module id = COrC
// module chunks = 0